var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("googleBusiness.locations"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.syncing },
              on: { click: _vm.syncLocations },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "16px", "margin-right": "4px" },
                },
                [_vm._v("sync")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("googleBusiness.sync")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { loading: _vm.loading },
              on: { click: _vm.fetchLocations },
            },
            [
              _c("a-icon", { attrs: { type: "reload" } }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("googleBusiness.refresh")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "locations-container" },
          _vm._l(_vm.locations, function (location) {
            return _c(
              "div",
              { key: location.locationId, staticClass: "location-card" },
              [
                _vm._m(0, true),
                _vm._v(" "),
                _c("div", { staticClass: "info" }, [
                  _c("h3", { staticClass: "location-name" }, [
                    _vm._v(_vm._s(location.name)),
                  ]),
                  _vm._v(" "),
                  location.address
                    ? _c("div", { staticClass: "location-address" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("location_on"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(location.address) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "meta" }, [
                    location.phoneNumber
                      ? _c("span", [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("phone"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(location.phoneNumber) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    location.averageRating
                      ? _c("span", [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("star"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(location.averageRating.toFixed(1)) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    location.totalReviewCount
                      ? _c("span", [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("reviews"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(location.totalReviewCount) +
                              " reviews\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "loading" }, [_c("a-spin")], 1),
    _vm._v(" "),
    !_vm.loading && _vm.locations.length === 0
      ? _c(
          "div",
          { staticClass: "empty" },
          [
            _c("a-empty", {
              attrs: { description: _vm.$t("googleBusiness.noLocationsFound") },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.totalPages > 1
      ? _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("a-pagination", {
              attrs: {
                current: _vm.page,
                total: _vm.total,
                "page-size": _vm.limit,
              },
              on: { change: _vm.onPageChange },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("store")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }